import axios from 'axios';
import Vue from 'vue';
const VERSION = "10.25.3.2";

var ConfigRepository = function () {
	
	var _config = null;

	function _callApi(action) {

		var url = _config.endPointUrl + 'api/terminal/' + action;

		// Creating a promise
		var promise = new Promise(function (resolve, reject) {
			// axios, for a full list of options see: https://github.com/axios/axios
			axios({
				method: 'GET',
				url: url
			}).then(function (response) {
				resolve(response.data);
			}).catch(function (err) {
				window.console.log('#ConfigRepository: Error calling ' + action + ' :' + err);
				reject(err);
			});
		});

		return promise;
    }
	var _data = new Vue({

		data: {

			orders: [],
			version: VERSION,
			serverVersion: 'Onbekend',
			showOrders: true,
			showReciepts: true,
			showBonChef: true,
			configLoaded: false,
			/*
				Default values for the status ids, realtime values are retrieved from the server
			*/
			statusIds: [0, 1, 2, 3, 4],
			/*
				Default values for the status tekst fields, realtime values are retrieved from the server
			*/
			statusText: { '0': 'INGEPLAND', '1': 'BEREIDEN', '2': 'GEREED', '3': 'WORDT INGEPAKT', '4': 'INGEPAKT' },

			newOrderAudio: '/Audio/neworder.wav',

			mouseflowProjectId: '',
			/*
			 The timeout in seconds, after which the tablenumber gets deselected
			*/
			tableSelectionExpiryTime: 60,

			endPointUrl: '',

			loginToken: 'loginToken',

			user: { name: '-' },
		},

		methods: {

			getAllUnits: function () {
				return _callApi('getallunits');
			},


			/**
			* Gets the settings from the server
			*/
			getSettingsFromServer: function () {
				
				return _callApi('getsettings').then((response) => {
					this.statusIds.splice(0, this.statusIds.length);
					this.statusIds.push(...response.statusIds);
					this.statusText = response.statusText;
					this.newOrderAudio = response.newOrderAudio;
					this.mouseflowProjectId = response.mouseflowProjectId;
					this.tableSelectionExpiryTime = response.tableSelectionExpiryTime;
					Vue.set(this, 'serverVersion', response.serverVersion);
					this.configLoaded = true;
				});
			},

			// gets the configuration from localstorage
			getConfig: function () {

				if (_config == null) {

					var configstring = window.localStorage.getItem('config');
					var config;

					if (configstring != null) {
						try {
							config = JSON.parse(configstring);
						} catch (e) {
							window.console.log('Error parsing config json string' + configstring);
						}
					}

					if (config == null) {
						config = {
							unitGroupIds: [],
							endPointUrl: '',
							playSound: true
						}

						this.saveConfig(config);
					}
					if (typeof config.collectUnitGroupIds === "undefined") {
						config.collectUnitGroupIds = [];
					}
					_config = config;
				}

				return _config;
			},

			saveConfig: function (config) {
				//set config
				window.localStorage.setItem('config', JSON.stringify(config));
				_config = config;
				this.init();
			},


			init: function () {
				var config = this.getConfig();
				this.getSettingsFromServer();
				this.endPointUrl = config.endPointUrl;
				this.loginToken = config.loginToken;
				this.showOrders = config.showOrders;
				this.showReciepts = config.showReciepts;
				this.showCollect = config.showCollect;
				this.showServe = config.showServe;
				this.showBonChef = config.showBonChef;
				this.clientName = config.clientName;
			}
		}
	});



	_data.init();

	return _data;
}()

export { ConfigRepository as default };
